//START GENAI@CHATGPT4
export const getSrcEmailMask = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const payload = JSON.parse(atob(base64));
    return payload.src_email_mask;
  } catch (e) {
    return null;
  }
};
//END GENAI@CHATGPT4
